import { forwardRef } from "react";
import { FormInput } from "./index";

function NumericFormInput(
  { label, name, id = name, errors, controlProps, ...rest }, ref
) {
  return (
    <FormInput id={id} name={name}
               type="number"
               step='0.001'
               onWheel={e => e.target.blur()}
               errors={errors} label={label}
               controlProps={controlProps} {...rest} ref={ref}  />
  );
}

export default forwardRef(NumericFormInput);
